// @flow
import SalesByFunds from './SalesByFunds';
import { dataKey } from './dataKey';


export default SalesByFunds;
export { dataKey };
